// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"230bd99b","237":"302ba332","426":"40e6f381","453":"51d8bfbf","460":"910c1e51","934":"686edff2","954":"6a12e3c1"}[chunkId] + ".chunk.js";
};